'use strict';

angular.module('app')
  .service('MarineLife', function (Request,$location, $timeout) {
    var _this = this

    return {
      getMarineLife : function () {
        return Request.get('marine-life/wizard/').then(function(res){
          return res.data;
        });
      },
      sendParams : function (params) {
        var data = {};

        if (params.marine || params.critter) {
          data = {
            month: params.month,
            critter_id: params.critter ? params.critter.id : null,
            group_id: params.marine ? params.marine.id : null
          };
        } else if (params.critter_id || params.group_id) {
          data = {
            month: params.month,
            critter_id: params.critter_id,
            group_id: params.group_id
          }
        }

        $location.search(data);

        data.page = params.page;

        return Request.get('places/wizard/', data).then(function(res){
          _.each(res.data.results, function (val){
            val.rainfall = Math.round(parseFloat(val.rainfall));
            val.waterTemp = Math.round(parseFloat(val.waterTemp));
            val.airTemp = Math.round(parseFloat(val.airTemp));
          });

          return res.data;
        });
      },
      reinitializeShareButtons : function() {
        stButtons.makeButtons();
      }
    }
  });
